import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Missive Case Study | Canny';
const Description =
  'Read about how Missive uses Canny to cut down on support time and prioritize new features.';
const Image = 'https://canny.io/images/62108ff1159b342843c2c29f459776ac.jpg';

export default class MissiveLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },
          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/case-studies/missive' },
          { property: 'og:type', content: 'website' },
          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
